import { Spinner } from '@pidelo/web-ui';
import styles from './RouteLoading.module.css';

/** While the first page of a visit loads its part of the admin. */
export function RouteLoading() {
  return (
    <div className={styles.loading}>
      <Spinner size={28} label="Cargando el admin" />
    </div>
  );
}
